import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { primary, outline } from "./ConfirmButton";

const copy = async (text) => {
  try { await navigator.clipboard.writeText(text); return true; } catch { return false; }
};

export const ManualLinks = ({ a, onDone }) => {
  const [link, setLink] = useState(null);
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);

  const make = async (kind) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/accounts/${a.id}/${kind}`);
      const url = `${window.location.origin}${data.path}`;
      const ok = await copy(url);
      setLink({ kind, url, hours: data.expires_in_hours });
      setCopied(ok);
      toast.success(ok ? "Link copied. Send it by WhatsApp or SMS." : "Link ready. Copy it below.");
      onDone();
    } catch (e) { toast.error(errorMessage(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="rounded-xl border p-4 lg:col-span-2" data-testid="admin-manual-links-block">
      <p className="text-sm font-semibold text-foreground">Send a link manually</p>
      <p className="mt-0.5 text-xs text-muted-foreground">Use this when the email never arrives. Only send it to the account owner, it opens their account.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {!a.email_verified && <button type="button" className={primary} disabled={busy} onClick={() => make("verification-link")} data-testid="admin-verification-link-button">Get confirmation link</button>}
        {!a.is_self && <button type="button" className={a.email_verified ? primary : outline} disabled={busy} onClick={() => make("reset-link")} data-testid="admin-reset-link-button">Get password reset link</button>}
      </div>
      {link && (
        <div className="mt-3 space-y-1.5" data-testid="admin-manual-link-result">
          <div className="flex items-center gap-2">
            <input readOnly value={link.url} onFocus={(e) => e.target.select()} className="h-10 min-w-0 flex-1 rounded-lg border bg-muted px-3 text-xs text-foreground" data-testid="admin-manual-link-input" aria-label="Generated link" />
            <button type="button" className={outline} onClick={async () => setCopied(await copy(link.url))} data-testid="admin-manual-link-copy">
              {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
            </button>
          </div>
          <p className="text-xs text-muted-foreground" data-testid="admin-manual-link-expiry">
            {link.kind === "reset-link" ? "Password reset" : "Confirmation"} link, valid for {link.hours} hour{link.hours > 1 ? "s" : ""} and works once.
          </p>
        </div>
      )}
    </div>
  );
};
